import {
  TRACKING_INIT,
  TRACKING_SUCCESS,
  TRACKING_ERROR,
} from '../../actions/tracking/constants';

const initState = {
  loading: false,
  data: null,
  error: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case TRACKING_INIT:
      return { ...state, loading: true, data: null, error: null };
    case TRACKING_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case TRACKING_ERROR:
      return { ...state, loading: false, data: null, error: action.payload };
    default:
      return state;
  }
};
